import cx from "classnames";
import React from "react";
import styles from "./Topo.scss";

export class Topo extends React.PureComponent {
  static defaultProps = {
    dark: false,
  };

  render() {
    const { className, dark, mint, children, ...props } = this.props;
    return (
      <div className={cx(styles.Topo, dark && styles.dark, mint && styles.mint, className)} {...props}>
        {children}
      </div>
    );
  }
}
